import { Search } from '@mui/icons-material';
import {
  FormControl,
  InputAdornment,
  OutlinedInput,
  Popover,
} from '@mui/material';
import { ChangeEvent, useRef, useState } from 'react';
import SearchList from './SearchList';

const SearchWidget = () => {
  const [searchText, setSearchText] = useState('');
  const [searchOpen, setSearchOpen] = useState<any>(null);
  const anchorRef = useRef<any>(null);
  const handleSearchChanged = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };
  const handleOpen = () => {
    setSearchOpen(true);
  };
  const handleClose = () => {
    setSearchText('');
    setSearchOpen(false);
  };
  return (
    <form ref={anchorRef}>
      <FormControl sx={{ m: 1, width: '25ch' }} variant='outlined'>
        <OutlinedInput
          value={searchText}
          id='field1'
          onChange={handleSearchChanged}
          size={'small'}
          startAdornment={
            <InputAdornment position='start' color='inherit'>
              <Search />
            </InputAdornment>
          }
          onFocus={handleOpen}
          sx={{
            borderColor: 'white',
            color: 'white',
            '& *': {
              color: 'white',
              borderColor: (theme) =>
                theme.palette.mode === 'light' ? 'white !important' : undefined,
            },
          }}
          inputProps={{ autoComplete: 'off' }}
        />
      </FormControl>
      <Popover
        open={!!searchOpen}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableAutoFocus
        disableEnforceFocus
        disableRestoreFocus
      >
        <SearchList searchText={searchText} handleClose={handleClose} />
      </Popover>
    </form>
  );
};

export default SearchWidget;
